export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-list-82930812a3b8b381e40c4b32bd1d39ac.svg";